import _defineProperty from "/Users/sachitha/Desktop/Developments/web/evoice360/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/Users/sachitha/Desktop/Developments/web/evoice360/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/sachitha/Desktop/Developments/web/evoice360/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FlagType, CountryCodeList } from './types';
import Fuse from 'fuse.js';
var imageJsonUrl = 'https://www.dropbox.com/s/raw/33tmsr0h3eggjke/countries-image.json';
var localData = {
  emojiCountries: undefined,
  imageCountries: undefined
};
export var loadDataAsync = function (data) {
  return function () {
    var dataType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FlagType.EMOJI;
    return new Promise(function (resolve, reject) {
      switch (dataType) {
        case FlagType.FLAT:
          if (!data.imageCountries) {
            fetch(imageJsonUrl).then(function (response) {
              return response.json();
            }).then(function (remoteData) {
              data.imageCountries = remoteData;
              resolve(data.imageCountries);
            }).catch(reject);
          } else {
            resolve(data.imageCountries);
          }

          break;

        default:
          if (!data.emojiCountries) {
            data.emojiCountries = require('./assets/data/countries-emoji.json');
            resolve(data.emojiCountries);
          } else {
            resolve(data.emojiCountries);
          }

          break;
      }
    });
  };
}(localData);
export var getEmojiFlagAsync =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var countryCode,
        countries,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            countryCode = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'FR';
            _context.next = 3;
            return loadDataAsync();

          case 3:
            countries = _context.sent;

            if (countries) {
              _context.next = 6;
              break;
            }

            throw new Error('Unable to find emoji because emojiCountries is undefined');

          case 6:
            return _context.abrupt("return", countries[countryCode].flag);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getEmojiFlagAsync() {
    return _ref.apply(this, arguments);
  };
}();
export var getImageFlagAsync =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var countryCode,
        countries,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            countryCode = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'FR';
            _context2.next = 3;
            return loadDataAsync(FlagType.FLAT);

          case 3:
            countries = _context2.sent;

            if (countries) {
              _context2.next = 6;
              break;
            }

            throw new Error('Unable to find image because imageCountries is undefined');

          case 6:
            return _context2.abrupt("return", countries[countryCode].flag);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getImageFlagAsync() {
    return _ref2.apply(this, arguments);
  };
}();
export var getCountryNameAsync =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var countryCode,
        translation,
        countries,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            countryCode = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'FR';
            translation = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'common';
            _context3.next = 4;
            return loadDataAsync();

          case 4:
            countries = _context3.sent;

            if (countries) {
              _context3.next = 7;
              break;
            }

            throw new Error('Unable to find image because imageCountries is undefined');

          case 7:
            return _context3.abrupt("return", countries[countryCode].name ? countries[countryCode].name[translation] : countries[countryCode].name['common']);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getCountryNameAsync() {
    return _ref3.apply(this, arguments);
  };
}();
export var getCountryCallingCodeAsync =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(countryCode) {
    var countries;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return loadDataAsync();

          case 2:
            countries = _context4.sent;

            if (countries) {
              _context4.next = 5;
              break;
            }

            throw new Error('Unable to find image because imageCountries is undefined');

          case 5:
            return _context4.abrupt("return", countries[countryCode].callingCode[0]);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getCountryCallingCodeAsync(_x) {
    return _ref4.apply(this, arguments);
  };
}();
export var getCountryCurrencyAsync =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(countryCode) {
    var countries;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return loadDataAsync();

          case 2:
            countries = _context5.sent;

            if (countries) {
              _context5.next = 5;
              break;
            }

            throw new Error('Unable to find image because imageCountries is undefined');

          case 5:
            return _context5.abrupt("return", countries[countryCode].currency[0]);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getCountryCurrencyAsync(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

var isCountryPresent = function isCountryPresent(countries) {
  return function (countryCode) {
    return !!countries[countryCode];
  };
};

var isRegion = function isRegion(region) {
  return function (country) {
    return region ? country.region === region : true;
  };
};

var isSubregion = function isSubregion(subregion) {
  return function (country) {
    return subregion ? country.subregion === subregion : true;
  };
};

var isIncluded = function isIncluded(countryCodes) {
  return function (country) {
    return countryCodes && countryCodes.length > 0 ? countryCodes.includes(country.cca2) : true;
  };
};

export var getCountriesAsync =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(flagType) {
    var translation,
        region,
        subregion,
        countryCodes,
        countriesRaw,
        countries,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            translation = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : 'common';
            region = _args6.length > 2 ? _args6[2] : undefined;
            subregion = _args6.length > 3 ? _args6[3] : undefined;
            countryCodes = _args6.length > 4 ? _args6[4] : undefined;
            _context6.next = 6;
            return loadDataAsync(flagType);

          case 6:
            countriesRaw = _context6.sent;

            if (countriesRaw) {
              _context6.next = 9;
              break;
            }

            return _context6.abrupt("return", []);

          case 9:
            countries = CountryCodeList.filter(isCountryPresent(countriesRaw)).map(function (cca2) {
              return _objectSpread({
                cca2: cca2
              }, _objectSpread({}, countriesRaw[cca2], {
                name: countriesRaw[cca2].name[translation] || countriesRaw[cca2].name['common']
              }));
            }).filter(isRegion(region)).filter(isSubregion(subregion)).filter(isIncluded(countryCodes)).sort(function (country1, country2) {
              return country1.name.localeCompare(country2.name);
            });
            return _context6.abrupt("return", countries);

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getCountriesAsync(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var DEFAULT_FUSE_OPTION = {
  shouldSort: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['name', 'callingCode']
};
var fuse;
export var search = function search() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_FUSE_OPTION;

  if (data.length === 0) {
    return [];
  }

  if (!fuse) {
    fuse = new Fuse(data, options);
  }

  if (filter && filter !== '') {
    var result = fuse.search(filter);
    return result;
  } else {
    return data;
  }
};

var uniq = function uniq(arr) {
  return Array.from(new Set(arr));
};

export var getLetters = function getLetters(countries) {
  return uniq(countries.map(function (country) {
    return country.name.substr(0, 1).toLocaleUpperCase();
  }).sort(function (l1, l2) {
    return l1.localeCompare(l2);
  }));
};